module.exports = __webpack_public_path__ + "img/mar-month.040a5980.png";